import { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { getDaysLeftInTrial } from '../../util/getDaysLeftInTrial';
import { getModalKey } from '../../util/getModalKey';
import type { TrialDetailsQuery as TrialDetailsQueryData } from '../../queries/__types__/TrialDetailsQuery';
import { useUserInfoActions } from '../../store/userInfoStore';
import { useHandleHookStates, TIME } from '../useHandleHookStates';
import { TrialDetailsQuery } from '../../queries/TrialDetailsQuery.graphql';

export const useLoadTrialInfoToStore = (skip: boolean) => {
	const { setTrialEndDate, setDaysLeftInTrial, setModalKey, setBillingSourceSystem } =
		useUserInfoActions();
	// in trial and days left in trial
	const {
		data: trialData,
		loading: timeLeftTrialLoading,
		error: timeLeftTrialError,
	} = useQuery<TrialDetailsQueryData>(TrialDetailsQuery, {
		skip,
	});

	// calculate days left in trial
	const trialEndDate = trialData?.license?.trialEndDate || '';
	const daysLeftInTrial = getDaysLeftInTrial(trialEndDate);

	// get modal key for EP and Feature Discovery
	const modalKey = getModalKey(daysLeftInTrial);

	useEffect(() => {
		void setTrialEndDate(trialEndDate);
	}, [setTrialEndDate, trialEndDate]);

	useEffect(() => {
		void setDaysLeftInTrial(daysLeftInTrial);
	}, [setDaysLeftInTrial, daysLeftInTrial]);

	useEffect(() => {
		void setModalKey(modalKey);
	}, [setModalKey, modalKey]);

	// get billing source system (HAMS or CCP)
	const billingSourceSystem = trialData?.license?.billingSourceSystem;

	useEffect(() => {
		if (billingSourceSystem) {
			void setBillingSourceSystem(billingSourceSystem);
		}
	}, [setBillingSourceSystem, billingSourceSystem]);

	useHandleHookStates({
		loading: timeLeftTrialLoading,
		error: timeLeftTrialError,
		hook: TIME,
	});

	return { timeLeftTrialLoading, timeLeftTrialError };
};
